<template>
  <el-footer class="y-fl-footer h_footer">
    <el-row align="middle">
      <el-col style="text-align: right" class="fl-footer-icon-ctr">
        <i class="el-icon-lock"></i>
      </el-col>
    </el-row>
  </el-footer>
</template>

<script>
export default {}
</script>

<style>
.y-fl-footer {
  border-top: 1px solid #e0dddc;
  height: 47px !important;
  line-height: 47px;
}
.fl-footer-icon-ctr {
  text-align: right;
  vertical-align: middle;
}
</style>
